import { useCartAuth } from "@/hooks/use-cart-auth";
import { useCartStaleness } from "@/hooks/use-cart-staleness";
import { useCartSync } from "@/hooks/use-cart-sync";
import { useAbandonedCart } from "@/hooks/use-abandoned-cart";

/**
 * Invisible component that manages the full cart lifecycle:
 * - Clears cart on logout (privacy on shared devices)
 * - Validates prices/stock against the database (staleness)
 * - Syncs cart to Supabase for logged-in users (cross-device)
 * - Snapshots abandoned carts for CRM recovery campaigns
 *
 * Mount once in App, outside of Suspense boundaries.
 */
export function CartLifecycle() {
  useCartAuth();
  useCartStaleness();
  useCartSync();
  useAbandonedCart();
  return null;
}
